export const demo = [
  {
    id: 0,
    title: "Demo 1",
    content: "This is a demo todo I plan on tackling by month-end",
    done: false,
    due: "2022-10-21"
  },
  {
    id: 1,
    title: "Demo 2",
    content: "This is a demo todo I plan on tackling by month-end",
    done: true,
    due: "2022-10-21"
  },
  {
    id: 2,
    title: "Demo 3",
    content: "This is a demo todo I plan on tackling by month-end",
    done: false,
    due: "2023-10-21"
  }
]

export const todoItem = {
  id: 0,
  title: "",
  content: "",
  done: false,
  due: 0
}